import React, { Component } from 'react';
import { UnmountClosed } from 'react-collapse';
import moment from 'moment-timezone';

import Icon from './../Icon';
import Emoji from './../Emoji';
import FinalPaperFileRow from './FinalPaperFileRow';

import { STATUS_PROGRESS } from './../../store/orders/actions';

class OrderFinalPaperList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: true
        }

        this.toggle = this.toggle.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    toggle() {
        this.setState(state => Object.assign({}, state, {
            isOpen: !state.isOpen
        }));
    }

    onChange(event) {
        const { uploadFile } = this.props;
        const fileList = event.target.files;
        for (let i = 0; i < fileList.length; i++) {
            uploadFile(fileList[i], 'paper');
        }
        event.target.value = '';
    }

    renderPlagReport() {
        const { status, fileList, plagreport } = this.props;
        if (status !== STATUS_PROGRESS || !fileList.length) {
            return null;
        }
        switch (plagreport) {
            case 'OK':
                return (
                    <div className="bg-context bg-success mb15">
                        <Emoji id="like" />No plagiarism found. Your order will automatically be completed.
                    </div>
                );
            case 'PLAGIARISM':
                return (
                    <div className="bg-context bg-danger mb15">Plagiarism found. Check plag report(s).</div>
                );
            default:
                return null;
        }
    }

    getPlagFileHref(id) {
        if (!id) {
            return null;
        }
        const { plagFileList } = this.props;
        if (!plagFileList || !plagFileList.length) {
            return null;
        }
        const file = plagFileList.filter(file => file._id === id)[0];
        if (!file) {
            return null;
        }
        const comment = file.comment;
        if (!comment) {
            return null;
        }
        const percentStr = comment.match(/Level:(\d+)/)[1];
        if (!percentStr) {
            return null;
        }
        const percent = parseFloat(percentStr);
        if (isNaN(percent)) {
            return null;
        }
        if (percent > 7) {
            return file.location;
        }
        return null;
    }

    render() {
        const { fileList, onResize, status, removeFile} = this.props;
        const { isOpen } = this.state;
        if (!fileList.length) {
            return null;
        }
        const sortedList = fileList.sort((a, b) => moment(b.created_at).diff(moment(a.created_at)));

        const filesStr = `${sortedList.length} ${sortedList.length === 1 ? 'file' : 'files'}`;

        return (
            <div className="order-tab-collapse">
                <div className="order-tab-collapse-head" onClick={this.toggle}>
                    <Icon className="svg-icon" iconName="clip" />
                    <span className="order-tab-head-name">Final papers ({filesStr})</span>
                    {isOpen
                        ? <span className="arrow-down active"></span>
                        : <span className="arrow-down"></span>
                    }
                </div>
                <UnmountClosed isOpened={isOpen} className="order-tab-collapse-body" onRender={onResize}>
                    <div className="order-tab-content">
                        {status === STATUS_PROGRESS &&
                            <div className="row space-between vertical mb15">
                                <div>
                                    {filesStr} uploaded
                                </div>
                            </div>
                        }
                        {this.renderPlagReport()}
                        <div>
                            {sortedList.map(file =>
                                <FinalPaperFileRow file={file} plagFileHref={this.getPlagFileHref(file.plagreport_id)} key={file._id} onRemove={status === STATUS_PROGRESS && removeFile} />
                            )}
                        </div>
                    </div>
                </UnmountClosed>
            </div>
        );
    }
}
export default OrderFinalPaperList;


// WEBPACK FOOTER //
// ./src/components/order/OrderFinalPaperList.js